var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVeloLogotype = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 68.5388,
  height: 15.2397,
  viewBox: "0 0 68.5388 15.2397",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Velo Logotype"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector (Stroke)",
  d: "M59.282 7.57994C59.282 4.25716 56.6315 1.58387 53.3869 1.58387C50.1424 1.58391 47.4921 4.25719 47.4921 7.57994C47.4921 10.9027 50.1424 13.576 53.3869 13.576C56.6315 13.576 59.282 10.9027 59.282 7.57994ZM13.3558 0.869935C13.565 0.506892 14.0245 0.36805 14.4018 0.560806C14.7913 0.759789 14.9458 1.23681 14.7468 1.62629L8.12205 14.5936C7.98671 14.8585 7.71423 15.0253 7.41674 15.0253C7.11928 15.0253 6.84697 14.8585 6.71164 14.5936L0.0867028 1.62629L0.0692466 1.58939C-0.102187 1.20717 0.0544085 0.753599 0.431627 0.560806C0.808986 0.36802 1.26867 0.506872 1.47789 0.869935L1.49734 0.905731L7.41674 12.4924L13.3364 0.905731L13.3558 0.869935ZM30.1787 0.473968C30.616 0.473968 30.9706 0.828549 30.9706 1.2659C30.9706 1.70328 30.616 2.05784 30.1787 2.05784H19.6237V6.95771H28.1518C28.5891 6.95776 28.9437 7.3123 28.9437 7.74965C28.9437 8.18699 28.5891 8.54153 28.1518 8.54158H19.6237V13.4415H30.1787L30.2195 13.4423C30.638 13.4636 30.9706 13.8097 30.9706 14.2334C30.9706 14.6571 30.638 15.003 30.2195 15.0242L30.1787 15.0253H18.8317C18.3944 15.0253 18.0398 14.6707 18.0398 14.2334V1.2659L18.0407 1.22524C18.0619 0.806785 18.408 0.473968 18.8317 0.473968H30.1787ZM34.2455 1.2659C34.2455 0.828549 34.6001 0.473968 35.0374 0.473968C35.4748 0.473988 35.8294 0.828561 35.8294 1.2659V13.4415H44.6293C45.0666 13.4415 45.4212 13.796 45.4212 14.2334C45.4212 14.6707 45.0666 15.0253 44.6293 15.0253H35.0374C34.6001 15.0253 34.2455 14.6707 34.2455 14.2334V1.2659ZM60.8659 7.57994C60.8659 11.755 57.5286 15.1599 53.3869 15.1599C49.2454 15.1598 45.9082 11.755 45.9082 7.57994C45.9082 3.40493 49.2454 4.54143e-05 53.3869 0C57.5286 0 60.8659 3.4049 60.8659 7.57994Z",
  fill: "white",
  fillOpacity: 0.93
}), /*#__PURE__*/React.createElement("g", {
  id: "TM"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M65.3631 0.765429H65.8312L66.932 3.45404H66.9699L68.0707 0.765429H68.5388V4.00441H68.1719V1.54354H68.1402L67.1281 4.00441H66.7738L65.7616 1.54354H65.73V4.00441H65.3631V0.765429Z",
  fill: "white",
  fillOpacity: 0.93
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M62.3285 1.11337V0.765429H64.7577V1.11337H63.7392V4.00441H63.347V1.11337H62.3285Z",
  fill: "white",
  fillOpacity: 0.93
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVeloLogotype);
export default ForwardRef;